import { apiCall } from './ApiCall';

export const getAllColors = ({ cursor, limit } = {}) => apiCall("getallcouleurs")